import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { INTERNAL_LINKS } from '../utils/links';
import { THEME_COLORS } from '../utils/theme';
import { NavLogo } from './NavLogo';
import mlhBadge from '../assets/mlh-trust-badge-2022-white.svg';

const NavContainer = styled.div`
  position: absolute;
  top: 45px;
  width: 100vw;

  box-sizing: border-box;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding: 0 100px;

  z-index: 10;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  margin-right: 50px;
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  padding: 10px;
  color: ${THEME_COLORS.text};

  &.selected {
    font-weight: 700;
  }
`;

export const Nav: React.FC = () => {
  return (
    <NavContainer>
      <NavLogo />
      <LinkContainer>
        <StyledNavLink to={INTERNAL_LINKS.HOME} activeClassName="selected" exact>
          Home
        </StyledNavLink>
        <StyledNavLink to={INTERNAL_LINKS.ATTEND} activeClassName="selected" exact>
          Attend
        </StyledNavLink>
        <StyledNavLink to={INTERNAL_LINKS.COVID} activeClassName="selected" exact>
          COVID-19
        </StyledNavLink>
      </LinkContainer>
      <a
        id="mlh-trust-badge"
        style={{
          display: 'block',
          position: 'absolute',
          right: '45px',
          top: '-45px',
          zIndex: 10000,
        }}
        href="https://mlh.io/seasons/2022/events?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2022-season&utm_content=white"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={mlhBadge} alt="Major League Hacking 2022 Hackathon Season" width={70} height={122} />
      </a>
    </NavContainer>
  );
};
